// @flow

import * as React from 'react'
import type { PropsSchema, BasicProps } from '../../type'
import computeData from '../hoc/computeData'
import styledJsx from '../hoc/styledJsx'

type Props = BasicProps & {
  style: { [string]: string },
  html: string
};
@styledJsx
@computeData({ includeData: true })
export default class Html extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      type: 'style',
      group: 'text'
    },
    'separator',
    {
      type: 'html'
    }
  ];

  render () {
    const { id, style, visible, jsEnv } = this.props
    if (!visible) {
      return null
    }
    let { html = '' } = this.props
    html = jsEnv.runCode('html') || jsEnv.getString(html)

    return (
      <div style={style} id={id}>
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/Html.js